<div id="right-navigation">
	<nav>
		<ul class="toolbar">
			<li>
				<stages-menu
					[menuId]="'menu_process_actions'"
					[items]="menuItems()"
					iconClasses="ico ico-more-vertical"
					openTo="left"
					[noCollapse]="true"
				>
				</stages-menu>
			</li>
			@for (button of buttons(); track button) {
			<li [ngClass]="{ active: button.active() }">
				<a
					role="button"
					[attr.title]="button.title | translate"
					[attr.aria-label]="button.title | translate"
					(click)="button.on()"
					class="clickable"
				>
					<i [ngClass]="'ico ' + button.iconClass"></i>
					@if (button.secondIconClass) {
					<i [ngClass]="'ico ' + button.secondIconClass"></i>
					}
				</a>
			</li>
			}
		</ul>
	</nav>
</div>
